import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevron = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 8,
	viewBox: "0 0 12 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.41 0.589996L6 5.17L10.59 0.589996L12 2L6 8L0 2L1.41 0.589996Z",
		fill: "#697186"
	})
});
export default SvgChevron;
